import * as React from 'react';
import { SVGProps } from 'react';

const SvgForum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21 4.5H6c-.9 0-1.5.6-1.5 1.5v10.5c0 .9.6 1.5 1.5 1.5h6v-1.5H6V6h15v10.5h-5.4L12 21.6l1.2.9 3.15-4.5H21c.9 0 1.5-.6 1.5-1.5V6c0-.9-.6-1.5-1.5-1.5Z'
      fill='#000'
    />
    <path
      d='M3 13.5H1.5V3.75c0-1.275.975-2.25 2.25-2.25h9.75V3H3.75C3.3 3 3 3.3 3 3.75v9.75Z'
      fill='#000'
    />
  </svg>
);

export default SvgForum;
